import { apiFetch, parseApiError } from './client';

function buildQuery(filters = {}) {
  const params = new URLSearchParams();
  const entries = {
    start: filters.start,
    end: filters.end,
    eventId: filters.eventId,
    venueId: filters.venueId,
    accountId: filters.accountId,
  };

  Object.entries(entries).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    params.set(key, String(value));
  });

  return params.toString();
}

async function fetchJourneyJson(path, fallbackMessage) {
  const response = await apiFetch(path, { method: 'GET' });
  if (!response.ok) {
    throw new Error(await parseApiError(response, fallbackMessage));
  }
  return response.json();
}

/** GET /api/funnel — attendance funnel (ticket → scan → POS). */
export async function fetchFunnel(filters = {}) {
  const query = buildQuery(filters);
  const path = query ? `/api/funnel?${query}` : '/api/funnel';
  return fetchJourneyJson(path, 'Failed to load funnel data');
}

/** GET /api/funnel/membership — ticket → season card → add-on. */
export async function fetchMembershipFunnel(filters = {}) {
  const query = buildQuery(filters);
  const path = query ? `/api/funnel/membership?${query}` : '/api/funnel/membership';
  return fetchJourneyJson(path, 'Failed to load membership funnel data');
}

/** GET /api/funnel/sales-channel — online vs on-site (channel split may be null). */
export async function fetchSalesChannelFunnel(filters = {}) {
  const query = buildQuery(filters);
  const path = query ? `/api/funnel/sales-channel?${query}` : '/api/funnel/sales-channel';
  return fetchJourneyJson(path, 'Failed to load sales-channel funnel data');
}

/** GET /api/paths — aggregate journey paths. */
export async function fetchPaths(filters = {}) {
  const query = buildQuery(filters);
  const path = query ? `/api/paths?${query}` : '/api/paths';
  return fetchJourneyJson(path, 'Failed to load paths data');
}

/** GET /api/filters — real venue/event dropdown options. */
export async function fetchJourneyFilters({ accountId } = {}) {
  const query = buildQuery({ accountId });
  const path = query ? `/api/filters?${query}` : '/api/filters';
  return fetchJourneyJson(path, 'Failed to load filter options');
}
